var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnDemand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6129 31.5114H5.98715C4.47934 31.5097 3.03378 30.91 1.9676 29.8438C0.901421 28.7776 0.301697 27.332 0.300003 25.8242V6.38714C0.301697 4.87934 0.901421 3.43377 1.9676 2.36759C3.03378 1.30141 4.47934 0.701691 5.98715 0.699997H26.6129C28.1207 0.701691 29.5662 1.30141 30.6324 2.36759C31.6986 3.43377 32.2983 4.87934 32.3 6.38714V25.8242C32.2983 27.332 31.6986 28.7776 30.6324 29.8438C29.5662 30.91 28.1207 31.5097 26.6129 31.5114V31.5114ZM5.98715 3.28681C5.165 3.28765 4.37675 3.61452 3.79525 4.19571C3.21375 4.77691 2.88649 5.565 2.88522 6.38714V25.8242C2.88649 26.6464 3.21375 27.4345 3.79525 28.0157C4.37675 28.5969 5.165 28.9237 5.98715 28.9246H26.6129C27.4349 28.9237 28.2229 28.5968 28.8042 28.0156C29.3854 27.4343 29.7123 26.6462 29.7132 25.8242V6.38714C29.7123 5.56514 29.3854 4.77705 28.8042 4.19581C28.2229 3.61457 27.4349 3.28766 26.6129 3.28681H5.98715Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0501 8.27966L22.1367 16.1057L13.0501 23.9317"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnDemand);
export default __webpack_public_path__ + "static/media/on-demand.db23654d54f54c715bddcf6b9d7906de.svg";
export { ForwardRef as ReactComponent };